<template>
  <div>
    <div v-for="(group, gIndex) of groups" :key="gIndex" class="pt-4">
      <slot name="group-header" :groupName="group"></slot>
      <div v-for="(item, iIndex) of groupItems(group)" :key="iIndex">
        <slot name="list-item" :item="item" :index="iIndex"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    groupBy: { type: String, default: '' },
    groupList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    // Returns array with the groupings. If no group list is given one is created.
    groups: function () {
      // TODO throw if groupBy is not defined.
      if (this.groupList.length) return this.groupList
      return this.groupBy
        ? [...new Set(this.items.map((i) => i[this.groupBy]).sort())]
        : []
    },
  },
  methods: {
    groupItems: function (groupName) {
      console.log('GRP', this.items, this.groupBy)

      return this.items?.filter((i) => i[this.groupBy] == groupName) || []
    },
  },
}
</script>
